
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./error-reporting.cjs.production.min.js')
} else {
  module.exports = require('./error-reporting.cjs.development.js')
}
